import { Box, BoxProps, useTheme } from '@mui/material';
import { ALERT_SEVERITY, getAlertColor } from 'contexts/AlertsContext';
import { useEffect, useState } from 'react';

const Duration: React.FC<{ delay?: number; severity: ALERT_SEVERITY } & BoxProps> = ({
  delay = 2,
  severity,
  ...props
}) => {
  const theme = useTheme();
  const color = getAlertColor(severity, theme);
  const [width, setWidth] = useState(100);

  useEffect(() => {
    setWidth(0);
  }, []);

  return (
    <Box
      sx={{
        background: color,
        height: '2px',
        width: `${width}%`,
        transition: `width ${delay}s linear`,
      }}
      {...props}
    />
  );
};

export default Duration;
